import styled from "@emotion/styled";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Navbar from "./Navbar";

const SimpleTabs = ({
  children = [],
  location = {},
  onChangeTab,
  enableAutoScroll,
  newTabName,
  setNewTabName,
  rightComponent,
  leftComponent,
  drawerIsOpen,
  setDrawerIsOpen,
  userData,
  canLogin
}) => {
  const searchParams = new URLSearchParams(location.search);
  const containerRef = useRef(null);
  const [currIndex, setCurrIndex] = useState(0);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth)

  useEffect(() => {
     const handleResize = () => {
       setDeviceWidth(window.innerWidth);
     };
 
     window.addEventListener("resize", handleResize);
 
     return () => {
       window.removeEventListener("resize", handleResize);
     };
   }, []);

  const { tabs = [], tabsNames } = useMemo(() => {
    let tabs = [];

    if (children) {
      if (children.length > 1) {
        tabs = children.filter((child) => child.props?.tablabel);
      } else {
        tabs = [children];
      }
    }

    tabs = tabs.filter((child) => !child.props?.hide);

    return {
      tabs,
      tabsNames: tabs.map((child) => child.props?.tablabel),
    };
  }, [children]);

  const handleOnChangeTab = (index, rest) => {
    setCurrIndex(index);
    setDrawerIsOpen(false);

    if (onChangeTab) onChangeTab(tabs[index]?.props);

    const container = containerRef.current;
    if (container && enableAutoScroll) {
      const target = container.children[index];
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  };

  const header = useMemo(() => {
    return (
      <>
        <div className="content-tabs" ref={containerRef}>
          {deviceWidth <= 930 ? (
            <Navbar
              userData={userData}
              drawerIsOpen={drawerIsOpen}
              setDrawerIsOpen={setDrawerIsOpen}
              tabsNames={tabsNames}
              handleOnChangeTab={handleOnChangeTab}
              currIndex={currIndex}
              rightComponent={rightComponent}
            />
          ) : (
            <>
              {leftComponent && leftComponent()}
              <div className="content-tabs-items">
                {tabsNames.map((title, index) => (
                  <a
                    key={index}
                    type="button"
                    className={`tabs-item ${index === currIndex ? "active" : "disabled"
                      }`}
                    disabled={index === currIndex}
                    onClick={(rest) => handleOnChangeTab(index, rest)}
                  >
                    <span className={index === currIndex ? "active" : "disabled"}>
                      {title}
                    </span>
                    {index === currIndex ? (
                      <span className="selected-tab" />
                    ) : (
                      <span />
                    )}
                  </a>
                ))}
              </div>
              {rightComponent && rightComponent()}
            </>
          )}
        </div>
      </>
    );
  }, [
    tabsNames,
    currIndex,
    handleOnChangeTab,
    deviceWidth,
    drawerIsOpen,
    rightComponent,
    userData,
    leftComponent,
    setDrawerIsOpen,
  ]);

  const body = useMemo(
    () => (
      <div className="content-body">
        {tabs.map((child, index) => (
          <div key={index} className={index !== currIndex ? "hide-tab" : ""}>
            {child}
          </div>
        ))}
      </div>
    ),
    [tabs, currIndex]
  );

  useEffect(() => {
    const tabName = searchParams.get("tab");

    if (tabName) {
      const tabIndex = children.findIndex(
        (child) => child.props?.tabUrlName === tabName && !child.props?.hide
      );

      if (tabIndex > -1) {
        setCurrIndex(tabIndex);
      }
    }
  }, []);

  useEffect(() => {
    if (newTabName) {
      const tabIndex = children.findIndex(
        (child) => child.props?.tablabel === newTabName && !child.props?.hide
      );

      if (tabIndex > -1) {
        setCurrIndex(tabIndex);
      }
      setNewTabName(null);
    }
  }, [newTabName, children, setNewTabName]);

  return (
    <Container className="content-simpletabs" drawerIsOpen={drawerIsOpen}>
      {header}
      <div className="border" />
      {body}
    </Container>
  );
};

export default SimpleTabs;

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex: 1;
  flex-direction: column;
  /* overflow: hidden; */

  .section-label span {
    justify-content: flex-start;
  }

  .content-tabs-items {
    display: flex;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
  }

  /* .user-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 16px;

    @media (max-width: 768px) {
      align-items: flex-start;
      height: auto;
      margin-top: 0;
    }
  } */

  .content-tabs {
    display: flex;
    flex-direction: row;
    color: rgba(255, 255, 255, 1);

    max-width: 100vw;
    overflow-y: scroll;
    justify-content: space-between;
    padding: 21px 24px;

    a.tabs-item {
      all: unset;
      padding: 8px 8px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      position: relative;
      white-space: nowrap;
      font-family: Roboto Condensed;
      font-size: 16px;
      font-weight: 400;
      line-height: 21.09px;
      text-align: center;
      text-transform: uppercase;
      letter-spacing: 0%;
      cursor: pointer;

      .selected-tab {
        color: #e1c683;
      }

      @media (max-width: 768px) {
        display: ${(props) => (props.drawerIsOpen ? "flex" : "none")};
      }
    }

    .icon-drawer {
      .bars-icon {
        width: 21px;
        height: 18px;
        color: #ffffff;
      }
      .close-icon {
        width: 20px;
        height: 32px;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        display: none;
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .active {
    font-weight: 600;
    color: #e1c683;
  }

  .content-body {
    display: flex;
    flex: 1;
    /* padding-top: 80px;

    @media (max-width: 768px) {
      padding-top: 90px;
    } */

    > div {
      display: flex;
      justify-content: flex-start;
      flex: 1;

      &.hide-tab {
        display: none !important;
      }
    }
  }
`;
